export enum ExperienceStyle {
  EDITORS_PICK = 'editors_pick',
  EVENTS = 'events',
  INSIDERS = 'insiders',
  SELF_EXPLORE = 'self_explore',
}
